import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  tableHeader: {
    display: 'grid',
    gridTemplateColumns: '32px 50px 1fr 90px 90px 80px',
    alignItems: 'center',
    padding: theme.spacing(0.5, 1),
    backgroundColor: theme.palette.grey[100],
    borderRadius: 4,
    marginBottom: theme.spacing(1),
  },
  headerCell: {
    fontSize: 12,
    fontWeight: 600,
    color: theme.palette.text.secondary,
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
  },
  headerActionsCell: {
    textAlign: 'right',
  },
  headerGap: {
    gap: 4,
  },
  infoIconWrapper: {
    display: 'flex',
    alignItems: 'center',
    color: 'inherit',
  },
  addButton: {
    marginTop: theme.spacing(1),
    color: theme.palette.primary.main,
  },
}))

export default useStyles
